import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductMonitor18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_663)'>
      <path
        d='M7.99999 9C7.44771 9 6.99999 8.55229 6.99999 8C6.99999 7.44772 7.44771 7 7.99999 7C8.55227 7 8.99999 7.44772 8.99999 8C8.99999 8.55229 8.55227 9 7.99999 9Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.99999 4.49243C6.0601 4.49243 4.87906 6.06026 3.62677 7.31256C3.25234 7.68698 3.25234 8.31301 3.62677 8.68744C4.87906 9.93973 6.0601 11.5076 7.99999 11.5076C9.93989 11.5076 11.1209 9.93973 12.3732 8.68744C12.7476 8.31301 12.7476 7.68698 12.3732 7.31256C11.1209 6.06027 9.93989 4.49243 7.99999 4.49243ZM7.99999 5.99243C9.28653 5.99243 10.1124 7.1731 10.9393 8C10.1124 8.82689 9.28653 10.0076 7.99999 10.0076C6.71345 10.0076 5.88754 8.82689 5.06065 8C5.88754 7.1731 6.71345 5.99243 7.99999 5.99243Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.75 8C15.75 3.71979 12.2802 0.25 8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 12.2802 3.71979 15.75 8 15.75C9.86999 15.75 11.5853 15.0877 12.9241 13.9849L16.4696 17.5303L17.5303 16.4697L13.9848 12.9242C15.0877 11.5854 15.75 9.87003 15.75 8ZM8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_663'>
        <rect
          width='18'
          height='18'
          fill='white'
          transform='matrix(-1 0 0 1 18 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

ProductMonitor18.displayName = 'ProductMonitor18';
export default ProductMonitor18;
